// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.close-drawer-btn {\n    position: absolute;\n    right: 0;\n    top: 20px;\n}\n.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {\n    margin-left: 0 !important;\n}\n.v-list-group\n    .v-list-group__header\n    .v-list-item__icon.v-list-group__header__append-icon {\n    min-width: 24px !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
